import { render } from "./ListNewsletter.vue?vue&type=template&id=4f607741&ts=true"
import script from "./ListNewsletter.vue?vue&type=script&lang=ts"
export * from "./ListNewsletter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__